import { Box, Button } from '@zillow/constellation-10';
import { useContext } from 'react';
import type { ErrorWizardStep, WizardStep } from '../wizard/wizardTypes';
import { WizardContext } from '../wizard/WizardContext';

export default function Footer({ isWizardLoading }: { isWizardLoading: boolean }) {
  const { goToNextStep, goToPreviousStep, currentStep, currentIndex, onNext, isNextDisabled, isBackDisabled } =
    useContext(WizardContext);
  const displayBackButton =
    typeof currentIndex === 'number' && currentIndex > 0 && ((currentStep as WizardStep).renderBackButton ?? true);

  return (
    <footer style={{ width: '100%' }}>
      <Box
        role="group"
        aria-label="Wizard steps navigation"
        css={{
          display: 'flex',
          marginTop: 'default',
          marginBottom: 'default',
          marginLeft: { base: 'default', lg: 'looser' },
          marginRight: { base: 'default', lg: 'looser' },
          justifyContent: 'space-between',
        }}
      >
        <span>
          {displayBackButton && (
            <Button
              tone="brand"
              emphasis="outlined"
              onClick={goToPreviousStep}
              disabled={isWizardLoading || isBackDisabled}
            >
              Back
            </Button>
          )}
        </span>
        <span>
          <Button
            tone="brand"
            emphasis="filled"
            onClick={onNext ?? goToNextStep}
            disabled={isWizardLoading || isNextDisabled}
          >
            {(currentStep as WizardStep | ErrorWizardStep).nextButtonText || 'Next'}
          </Button>
        </span>
      </Box>
    </footer>
  );
}
